import { loggedIn, invoiceNeedsPaying } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import {
  clearPaymentError,
  payInvoice,
  fetchBraintreeToken,
} from '../../../redux/modules/checkout';
import { getPendingOrdersCurrentCCStoreAddressForOrder } from '../../../redux/modules/root-reducer';

export const page = {
  path: paths.checkout.paymentDetails,
  isAllowed: [loggedIn, invoiceNeedsPaying],
  action: () => fetchBraintreeToken(),
};

export const pay = {
  actionPath: '/actions/checkout/payment-details/pay',
  nonceInput: 'nonce',
  orderIdInput: 'orderId',
  action: ({ body, state }) =>
    payInvoice(
      body.orderId,
      body.nonce,
      getPendingOrdersCurrentCCStoreAddressForOrder(state)
    ),
};

export const clearPaymentDetailsError = {
  actionPath: '/actions/checkout/payment-details/clear-error',
  action: () => clearPaymentError(),
};
